/**
* DevExpress Dashboard (_filter-item-surface.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { FilterItemPropertiesComposer } from '../properties-composers/_filter-item-properties-composer';
import { DataItemCollectionSurface } from '../sections/_data-item-collection-surface';
import { SectionDescriptors, surfaceItemsFactory } from '../_section-descriptors';
import { DataDashboardItemSurface } from './_base-item-surface';
export class FilterItemSurface extends DataDashboardItemSurface {
    fillSections() {
        this.dataSections.push(new DataItemCollectionSurface(this, SectionDescriptors.FilterDimensions));
    }
    constructor(dashboardItem, dashboardModel, dataSourceBrowser, notificationController) {
        super(dashboardItem, dashboardModel, dataSourceBrowser, notificationController);
    }
    getPropertiesComposer() {
        return new FilterItemPropertiesComposer(this._dashboardItemCustomization);
    }
}
surfaceItemsFactory.register('ComboBox', FilterItemSurface);
surfaceItemsFactory.register('ListBox', FilterItemSurface);
surfaceItemsFactory.register('TreeView', FilterItemSurface);
